import { PDFExport } from "@progress/kendo-react-pdf";
import { useEffect, useRef, useState } from "react";
import { _getStorageValue } from "../../comman/localStorage";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getFSIInputData, getFSILocal, getFSIPlotArea, getFSIPlotRoad, getFSIProperty, getFSIState, getFSIZone, getZoneState } from "../../action/searchHistory";

const FSI = (props) => {
    const [pdfDisabled, setPdfDisabled] = useState(false);
    const pdfExportComponent = useRef(null);
    const [zoneValue, setZoneValue] = useState([]);
    const [stateValue, setStateValue] = useState([]);
    const [localBody, setLocalBody] = useState([]);
    const [propertyType, setPropertyType] = useState([]);
    const [plotArea, setPlotArea] = useState([]);
    const [roadwidth, setRoadwidth] = useState([]);
    const [finalData, setFinalData] = useState([])

    const [selectedZone, setzoneSelect] = useState("")
    const [selectedState, setStateSelect] = useState("")
    const [selectedLocal, setLocalSelect] = useState("")
    const [selectedProperty, setPropertySelect] = useState("")
    const [selectedPlot, setPlotSelect] = useState("")
    const [selectedRoadwidth, setRoadWidthSelect] = useState("")

    const exportPDFWithComponent = () => {
        props.onDownload("Rental");
        setPdfDisabled(true);
        setTimeout(() => {
            if (pdfExportComponent.current) {
                pdfExportComponent.current.save();
            }
        }, 200);
        setTimeout(() => {
            setPdfDisabled(false);
        }, 1000);
    };

    const resetOutput = () => {
        setFinalData([])
    }

    useEffect(() => {
        resetOutput()
    }, [selectedZone, selectedState, selectedLocal, selectedProperty, selectedPlot, selectedRoadwidth])

    useEffect(() => {
        const onSuccess = (response) => {
            let zones = response?.data?.zones?.map((data) => ({ name: data }));
            setZoneValue(zones);
        };

        const onFailure = () => {
            setZoneValue([]);
        };

        _getStorageValue("USER_ID").then((userId) => {
            props.getFSIZone(userId, onSuccess, onFailure);
        });
    }, []);

    const onZoneChange = (e) => {
        let value = e.target.value
        setzoneSelect(value)

        if (!!value) {
            _getStorageValue("USER_ID").then((userId) => {
                props.getFSIState(userId, value, onSuccess, onFailure)
            })
            const onSuccess = (response) => {
                let states = response?.data?.state?.map((state) => ({ name: state.name }))
                setStateValue(states)
            }
            const onFailure = () => {
                setStateValue([])
            };
        }
        setStateSelect("")
        setLocalSelect("")
        setPropertySelect("")
        setPlotSelect("")
        setRoadWidthSelect("")
    }

    const onStateChange = (e) => {
        let value = e.target.value;
        setStateSelect(value);
        const data = {
            zone: selectedZone,
            state: value,
        }
        if (!!data) {
            _getStorageValue("USER_ID").then((userId) => {
                props.getFSILocal(userId, data, onSuccess, onFailure);
            });
            const onSuccess = (response) => {
                let localBodyData = response?.data?.local_body?.map((state) => ({ name: state.name }))
                setLocalBody(localBodyData)
            };
            const onFailure = () => {
                setLocalBody([])
            };
        }

        setLocalSelect("")
        setPropertySelect("")
        setPlotSelect("")
        setRoadWidthSelect("")
    }

    const onlocalChange = (e) => {
        let localValue = e.target.value;
        setLocalSelect(localValue)

        const data = {
            zone: selectedZone,
            state: selectedState,
            local: localValue
        }
        if (!!data) {
            _getStorageValue("USER_ID").then((userId) => {
                props.getFSIProperty(userId, data, onSuccess, onFailure);
            });
            const onSuccess = (response) => {
                let propertyData = response?.data?.property_type?.map((state) => ({ name: state.name }))
                setPropertyType(propertyData)
            };
            const onFailure = () => {
                setPropertyType([])
            };
        }

        setPropertySelect("")
        setPlotSelect("")
        setRoadWidthSelect("")
    }

    const onPropertyChange = (e) => {
        let propertyValue = e.target.value;
        setPropertySelect(propertyValue)

        const data = {
            zone: selectedZone,
            state: selectedState,
            local: selectedLocal,
            property: propertyValue
        }

        if (!!data) {
            _getStorageValue("USER_ID").then((userId) => {
                props.getFSIPlotArea(userId, data, onSuccess, onFailure);
            });
            const onSuccess = (response) => {
                let plotData = response?.data?.plot_area?.map((state) => ({ name: state.name }))
                setPlotArea(plotData)
            };
            const onFailure = () => {
                setPlotArea([])
            };
        }

        setPlotSelect("")
        setRoadWidthSelect("")
    }

    const onPlotChange = (e) => {
        let plotValue = e.target.value
        setPlotSelect(plotValue);

        const data = {
            zone: selectedZone,
            state: selectedState,
            local: selectedLocal,
            property: selectedProperty,
            plot: plotValue
        }

        if (!!data) {
            _getStorageValue("USER_ID").then((userId) => {
                props.getFSIPlotRoad(userId, data, onSuccess, onFailure);
            });
            const onSuccess = (response) => {
                const roadwidthData = response?.data?.roadwidth?.map((state) => ({ name: state.name }))
                setRoadwidth(roadwidthData)
            };
            const onFailure = () => {
                setRoadwidth([])
            };
        }
        setRoadWidthSelect("")
    }


    const onRoadChange = (e) => {
        let roadWidthValue = e.target.value
        setRoadWidthSelect(roadWidthValue);

        const data = {
            zone: selectedZone,
            state: selectedState,
            local: selectedLocal,
            property: selectedProperty,
            plot: selectedPlot,
            roadWidth: roadWidthValue
        }

        if (!!data) {
            _getStorageValue("USER_ID").then((userId) => {
                props.getFSIInputData(userId, data, onSuccess, onFailure);
            });
            const onSuccess = (response) => {
                const data = response?.data?.map((state) => ({ data: state }))
                setFinalData(data)
            };
            const onFailure = () => {
                setFinalData([])
            };
        }
    }

    return (
        <PDFExport
            ref={pdfExportComponent}
            paperSize="A4"
            landscape={true}
            fileName="Fsi.pdf"
            scale={0.8}
        >
            <div style={{ flexBasis: pdfDisabled ? "100%" : "45%" }}>
                <div className="fsi-calculations" style={{ display: "flex", justifyContent: "space-between", margin: "50px 40px" }}>
                    <div className="fsiInputContainer" style={{ flexBasis: "45%" }} >
                        <div style={{ height: 30 }} className="site-vist sitrepot branch-container">
                            <h3> FSI Calculation </h3>
                        </div>

                        {/* Zone */}
                        <div className="customer-details-sec" style={{ width: "100%" }}>
                            <label className="customer-title">{"ZONE"}</label>
                            <div className="down-arrow " style={{ width: "45%" }}>
                                {pdfDisabled ? (
                                    <div className="customer-desc" style={{ width: "100%", display: "flex", alignItems: "center" }}>
                                        {selectedZone || ""}
                                    </div>
                                ) : (
                                    <select
                                        className="customer-desc"
                                        style={{ width: "100%" }}
                                        value={selectedZone}
                                        onChange={onZoneChange}
                                    >
                                        <option value="NaN" label="Select" />
                                        {zoneValue?.map((data, key) => {
                                            return (
                                                <option
                                                    key={key}
                                                    value={data.name}
                                                    label={data.name}
                                                />
                                            );
                                        })}
                                    </select>
                                )}
                            </div>
                        </div>

                        {/* state*/}
                        <div className="customer-details-sec" style={{ width: "100%" }}>
                            <label className="customer-title">{"STATE"}</label>
                            <div className="down-arrow " style={{ width: "45%" }}>
                                {pdfDisabled ? (
                                    <div className="customer-desc" style={{ width: "100%", display: "flex", alignItems: "center" }}>
                                        {selectedState || ""}
                                    </div>
                                ) : (
                                    <select
                                        value={selectedState}
                                        onChange={onStateChange}
                                        className="customer-desc"
                                        style={{
                                            width: "100%", backgroundColor: !selectedZone ? "lightgrey" : "transparent",
                                            opacity: !selectedZone ? "0.5" : "1",
                                        }}
                                        disabled={!selectedZone}
                                    >
                                        <option value="NaN" label="Select" />
                                        {stateValue.map((data, key) => {
                                            return (
                                                <option
                                                    key={key}
                                                    value={data.name}
                                                    label={data.name}
                                                />
                                            );
                                        })}
                                    </select>
                                )}
                            </div>
                        </div>

                        {/* localbody*/}
                        <div className="customer-details-sec" style={{ width: "100%" }}>
                            <label className="customer-title">{"LOCAL_BODY"}</label>
                            <div className="down-arrow " style={{ width: "45%" }}>
                                {pdfDisabled ? (
                                    <div className="customer-desc" style={{ width: "100%", display: "flex", alignItems: "center" }}>
                                        {selectedLocal || ""}
                                    </div>
                                ) : (
                                    <select
                                        value={selectedLocal}
                                        onChange={onlocalChange}
                                        className="customer-desc"
                                        style={{
                                            width: "100%", backgroundColor: !selectedState ? "lightgrey" : "transparent",
                                            opacity: !selectedState ? "0.5" : "1",
                                        }}
                                        disabled={!selectedState}
                                    >
                                        <option value="NaN" label="Select" />
                                        {localBody.map((data, key) => {
                                            return (
                                                <option
                                                    key={key}
                                                    value={data.name}
                                                    label={data.name}
                                                />
                                            )
                                        })}
                                    </select>
                                )}
                            </div>
                        </div>

                        {/* property type */}
                        <div className="customer-details-sec" style={{ width: "100%" }}>
                            <label className="customer-title">{"PROPERTY_TYPE"}</label>
                            <div className="down-arrow " style={{ width: "45%" }}>
                                {pdfDisabled ? (
                                    <div className="customer-desc" style={{ width: "100%", display: "flex", alignItems: "center" }}>
                                        {selectedProperty || ""}
                                    </div>
                                ) : (
                                    <select
                                        value={selectedProperty}
                                        onChange={onPropertyChange}
                                        className="customer-desc"
                                        style={{
                                            width: "100%", backgroundColor: !selectedLocal ? "lightgrey" : "transparent",
                                            opacity: !selectedLocal ? "0.5" : "1",
                                        }}
                                        disabled={!selectedLocal}
                                    >
                                        <option value="NaN" label="Select" />
                                        {propertyType.map((data, key) => {
                                            return (
                                                <option
                                                    key={key}
                                                    value={data.name}
                                                    label={data.name}
                                                />
                                            )
                                        })}
                                    </select>
                                )}
                            </div>
                        </div>

                        {/* ploatarea */}
                        <div className="customer-details-sec" style={{ width: "100%" }}>
                            <label className="customer-title">{"PLOT_AREA"}</label>
                            <div className="down-arrow " style={{ width: "45%" }}>
                                {pdfDisabled ? (
                                    <div className="customer-desc" style={{ width: "100%", display: "flex", alignItems: "center" }}>
                                        {selectedPlot || ""}
                                    </div>
                                ) : (
                                    <select
                                        value={selectedPlot}
                                        onChange={onPlotChange}
                                        className="customer-desc"
                                        style={{
                                            width: "100%", backgroundColor: !selectedProperty ? "lightgrey" : "transparent",
                                            opacity: !selectedProperty ? "0.5" : "1",
                                        }}
                                        disabled={!selectedProperty}
                                    >
                                        <option value="NaN" label="Select" />
                                        {plotArea.map((data, key) => {
                                            return (
                                                <option
                                                    key={key}
                                                    value={data.name}
                                                    label={data.name}
                                                />
                                            )
                                        })}
                                    </select>
                                )}
                            </div>
                        </div>

                        {/* roadwidth */}
                        <div className="customer-details-sec" style={{ width: "100%" }}>
                            <label className="customer-title">{"ROADWIDTH"}</label>
                            <div className="down-arrow " style={{ width: "45%" }}>
                                {pdfDisabled ? (
                                    <div className="customer-desc" style={{ width: "100%", display: "flex", alignItems: "center" }}>
                                        {selectedRoadwidth || ""}
                                    </div>
                                ) : (
                                    <select
                                        value={selectedRoadwidth}
                                        onChange={onRoadChange}
                                        className="customer-desc"
                                        style={{
                                            width: "100%", backgroundColor: !selectedPlot ? "lightgrey" : "transparent",
                                            opacity: !selectedPlot ? "0.5" : "1",
                                        }}
                                        disabled={!selectedPlot}
                                    >
                                        <option value="NaN" label="Select" />
                                        {roadwidth.map((data, key) => {
                                            return (
                                                <option
                                                    key={key}
                                                    value={data.name}
                                                    label={data.name}
                                                />
                                            )
                                        })}
                                    </select>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Pre PopulatedValue */}
                    <div className="fsiOutputContainer" style={{ flexBasis: "45%" }}>
                        <div style={{ height: 30 }} className="site-vist sitrepot branch-container">
                            <h3> Outputs </h3>
                        </div>

                        <div className="customer-details-sec" style={{ width: "100%" }}>
                            <label className="customer-title">
                                {"SETBACKS"}
                            </label>
                            <input
                                type="text"
                                value={finalData[0]?.data?.setbacks || ""}
                                className="customer-desc"
                                style={{
                                    backgroundColor: "lightgrey",
                                }}
                                disabled={true}
                            />
                        </div>

                        <div className="customer-details-sec" style={{ width: "100%" }}>
                            <label className="customer-title">
                                {"FSI"}
                            </label>
                            <input
                                type="text"
                                value={finalData[0]?.data?.fsi || ""}
                                className="customer-desc"
                                style={{
                                    backgroundColor: "lightgrey",
                                }}
                                disabled={true}
                            />
                        </div>

                        <div className="customer-details-sec" style={{ width: "100%" }}>
                            <label className="customer-title">
                                {"PLOT COVERAGE"}
                            </label>
                            <input
                                type="text"
                                value={finalData[0]?.data?.plot_coverage || ""}
                                className="customer-desc"
                                style={{
                                    backgroundColor: "lightgrey",
                                }}
                                disabled={true}
                            />
                        </div>

                        <div className="customer-details-sec" style={{ width: "100%" }}>
                            <label className="customer-title">
                                {"PREMIUM FSI"}
                            </label>
                            <input
                                type="text"
                                value={finalData[0]?.data?.premium_fsi || ""}
                                className="customer-desc"
                                style={{
                                    backgroundColor: "lightgrey",
                                }}
                                disabled={true}
                            />
                        </div>

                        <div className="customer-details-sec" style={{ width: "100%" }}>
                            <label className="customer-title">
                                {"TDR"}
                            </label>
                            <input
                                type="text"
                                value={finalData[0]?.data?.tdr || ""}
                                className="customer-desc"
                                style={{
                                    backgroundColor: "lightgrey",
                                }}
                                disabled={true}
                            />
                        </div>

                        <div className="customer-details-sec" style={{ width: "100%" }}>
                            <label className="customer-title">
                                {"MAX_PERMISSIBLE_HEIGHT"}
                            </label>
                            <input
                                type="text"
                                value={finalData[0]?.data?.max_permissible_height || ""}
                                className="customer-desc"
                                style={{
                                    backgroundColor: "lightgrey",
                                }}
                                disabled={true}
                            />
                        </div>

                        <div className="customer-details-sec" style={{ width: "100%" }}>
                            <label className="customer-title">
                                {"APPROVING_AUTHORITY"}
                            </label>
                            <input
                                type="text"
                                value={finalData[0]?.data?.approving_authority || ""}
                                className="customer-desc"
                                style={{
                                    backgroundColor: "lightgrey",
                                }}
                                disabled={true}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <button
                className="pdf_btn"
                style={{ display: pdfDisabled ? "none" : "block" }}
                onClick={exportPDFWithComponent}
            >
                Download PDF
            </button>
        </PDFExport>
    )
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getFSIZone: getFSIZone,
        getFSIState: getFSIState,
        getFSILocal: getFSILocal,
        getFSIPlotArea: getFSIPlotArea,
        getFSIProperty: getFSIProperty,
        getFSIPlotRoad: getFSIPlotRoad,
        getFSIInputData: getFSIInputData,
    }, dispatch);
}

export default connect(null, mapDispatchToProps)(FSI);